<template>
  <p class="small text-muted">
    This form is protected by hCaptcha and its
    <a href="https://hcaptcha.com/privacy" target="_blank">Privacy Policy</a>
    and
    <a href="https://hcaptcha.com/terms" target="_blank">Terms of Service</a>
    apply.
  </p>
</template>
